import styled, { css } from 'styled-components';
import KitCard from '../KitCard';

const StyledCard = styled(KitCard)<{
  fullHeight?: boolean;
  minWidth?: string;
  maxWidth?: string;
}>`
  display: flex;
  flex-direction: column;
  ${({ fullHeight }) =>
    fullHeight &&
    css`
      height: 100%;
    `}
  ${({ minWidth }) =>
    minWidth &&
    css`
      min-width: ${minWidth};
    `}
  ${({ maxWidth }) =>
    maxWidth &&
    css`
      max-width: ${maxWidth};
    `}
`;

const StyledCardHeader = styled(KitCard.Header)`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const StyledCardBody = styled(KitCard.Body)`
  flex-grow: 1;
  position: relative;
`;

StyledCard.Header = StyledCardHeader;
StyledCard.Body = StyledCardBody;

export default StyledCard;
